<template>
  <div>
    <div class="row">
      <div class="col-11">
        <SectionTitle
          icon="fas fa-info-circle"
          content="Higiene"
          container-class="tag-badge mt-5 mb-4"
        />
      </div>
      <div v-if="canDelete && !disabled" class="col-1 d-flex justify-content-end align-items-center">
        <action-button
          i="far fa-times pointer icon-right color-primary-3 font-28"
          class="px-1 mr-2 "
          @click="$emit('delete')"
        />
      </div>
    </div>

    <div class="d-flex flex-column">
      <div class="question-element mt-2">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
            <b class="mb-0">
              El estudiante requiere cambio de pañal.
            </b>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable? 'required' : ''"
            >
              <custom-radio
                id="rgHygieneStudentRequireDiaperChange"
                v-model="value.requiresDiaperChange"
                :change-event="onRequireDiaperChange"
                name="studentRequireDiaperChange"
                label=""
                is-question-list
                :options="diaperChangeOptions"
                class="radio-button-container"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>
      <div class="question-element mt-2">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
            <b class="mb-0">
              El estudiante requiere adiestramiento en control de esfínteres.
            </b>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable? 'required' : ''"
            >
              <custom-radio
                id="rgHygieneStudentRequireSphincterTraining"
                v-model="value.requiresTraining"
                :change-event="onRequireTrainingChange"
                name="studentRequireTraining"
                label=""
                is-question-list
                :options="requiresTrainingOptions"
                class="radio-button-container"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>
      <div class="mt-4 pb-4 pr-2">
        <div>Comentarios Adicionales:</div>
        <CustomTextArea
          id="studentNeedsHygieneComments"
          v-model="value.comment"
          class="mt-2"
          :placeholder="'Escriba un comentario'"
          :maxlength="3000"
          show-char-count
          :count-classes="['d-block text-right']"
          :rows="5"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SectionTitle } from "@/components/pei/shared";
import CustomRadio from '@/components/common/CustomRadioBorder';
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";

export default {
  name: "Hygiene",
  components: {
    SectionTitle,
    CustomRadio,
    CustomTextArea,
    ActionButton
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    validable: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      diaperChangeOptions: [
        { label: "SI", value: true, check: false },
        { label: "NO", value: false, check: false }
      ],
      requiresTrainingOptions: [
        { label: "SI", value: true, check: false },
        { label: "NO", value: false, check: false }
      ]
    };
  },
  mounted() {
    // Marking the corresponding radio button options
    if (this.value.requiresDiaperChange != null) {
      let requiresDiaperCheck = this.diaperChangeOptions.find(
        r => r.value === this.value.requiresDiaperChange
      );
      requiresDiaperCheck.check = true;
    }

    if (this.value.requiresTraining != null) {
      let requiresTrainingCheck = this.requiresTrainingOptions.find(
        r => r.value === this.value.requiresTraining
      );
      requiresTrainingCheck.check = true;
    }
  },
  methods: {
    onRequireDiaperChange(item) {
      this.$emit("input", { ...this.value, requiresDiaperChange: item.value });
    },
    onRequireTrainingChange(item) {
      this.$emit("input", { ...this.value, requiresTraining: item.value });
    }
  }
};
</script>

<style scoped>
.item-pane {
  justify-content: space-between;
  min-width: 50%;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}

.radio-button-container >>> .cr-icon {
  opacity: 1 !important;
}
</style>
